"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAElementProps = useAElementProps;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useNormalizedUrl = _interopRequireDefault(require("../hooks/useNormalizedUrl"));
var _DocumentMetadataProvider = require("../context/DocumentMetadataProvider");
var _RenderersPropsProvider = require("../context/RenderersPropsProvider");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function useAnchorOnLinkPress(tnode, onPress) {
  var href = tnode.attributes.href;
  var normalizedHref = (0, _useNormalizedUrl.default)(href);
  var _ref = (0, _DocumentMetadataProvider.useDocumentMetadata)(),
    baseTarget = _ref.baseTarget;
  var shouldHandleLinkPress = tnode.tagName === 'a' && typeof normalizedHref === 'string' && href.length > 0 && typeof onPress === 'function';
  return shouldHandleLinkPress ? function (e) {
    return onPress(e, normalizedHref, tnode.attributes, tnode.attributes.target || baseTarget);
  } : undefined;
}
function useAElementProps(props) {
  var tnode = props.tnode;
  var _ref2 = (0, _RenderersPropsProvider.useRendererProps)('a'),
    onPress = _ref2.onPress;
  var syntheticAnchorOnLinkPress = useAnchorOnLinkPress(tnode, onPress);
  if (typeof syntheticAnchorOnLinkPress !== 'function') {
    return props;
  }
  return _objectSpread(_objectSpread({}, props), {}, {
    onPress: syntheticAnchorOnLinkPress
  });
}
var ARenderer = function ARenderer(props) {
  return /*#__PURE__*/_react.default.createElement(props.TDefaultRenderer, useAElementProps(props));
};
var _default = ARenderer;
exports.default = _default;